import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { Button } from './Button';
const PRODUCTS = [{
  name: 'Whole-Home Softener & Filtration',
  tag: 'Most Popular',
  img: 'https://cdn.magicpatterns.com/uploads/nJk6vDxqnDTZdZp9TP65cG/tulsa2.jpg',
  desc: 'Our complete all-in-one system removes hardness, chlorine, and harmful contaminants from every tap in your home.',
  features: ['Patented ceramic valve', '48,000-grain softening capacity', 'Coconut shell carbon filtration']
}, {
  name: 'Reverse Osmosis Drinking System',
  tag: 'Best for Kitchens',
  img: 'https://cdn.magicpatterns.com/uploads/txF5EQ3sh5i8CbJR81aimu/tulsa-honestwater.jpg',
  desc: 'Under-sink RO delivers bottled-quality drinking water straight from a sleek dedicated faucet.',
  features: ['Multi-stage purification', 'Sleek modern faucet', 'Endless clean drinking water']
}];
const RO_IMG = 'https://cdn.magicpatterns.com/uploads/txF5EQ3sh5i8CbJR81aimu/tulsa-honestwater.jpg';
export function Products() {
  return <section id="products" className="bg-slate-50 py-20 sm:py-24" data-id="element-110" data-mp="3fawdx55wudd9">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-111" data-mp="30lqf3iazip5w">
        <SectionHeading eyebrow="Our Systems" title="Premium water treatment, built to last" subtitle="Professionally installed, whole-home solutions engineered for Tulsa's water — backed by a true manufacturer lifetime warranty." data-id="element-112" data-mp="30n1fr994vgss" />

        <div className="mt-14 grid gap-8 md:grid-cols-2" data-id="element-113" data-mp="229rw08adpj2">
          {PRODUCTS.map((p, i) => <motion.article key={p.name} initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.1
        }} className="group flex flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-shadow hover:shadow-xl" data-id="element-114" data-mp="3k8fptyf4ye21" data-mpi={i}>
              <div className="relative aspect-[4/3] overflow-hidden bg-navy-900" data-id="element-115" data-mp="jezscppjop83">
                <img src={i === 1 ? RO_IMG : p.img} alt={p.name} className={`h-full w-full transition-transform duration-500 group-hover:scale-105 ${i === 1 ? 'object-contain p-4' : 'object-cover'}`} data-id="element-116" data-mp="eelx6891l9rh" />
                <span className="absolute left-4 top-4 rounded-full bg-brand-cyan px-3 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-117" data-mp="kcfp5zadn80">
                  {p.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6 sm:p-8" data-id="element-118" data-mp="3mvgn6n4qqzo5">
                <h3 className="font-heading text-xl font-extrabold text-navy-900 sm:text-2xl" data-id="element-119" data-mp="3hw3tpjjd6ucl">
                  {p.name}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-120" data-mp="1g3637ud28dut">{p.desc}</p>
                <ul className="mt-5 space-y-2.5" data-id="element-121" data-mp="1g1czamtu07qi">
                  {p.features.map(f => <li key={f} className="flex items-center gap-2.5 text-sm font-medium text-navy-900" data-id="element-122" data-mp="1oidj1gkl718h">
                      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-cyan/15 text-brand-blue" data-id="element-123" data-mp="1xci6dq0ihuj9">
                        <Check className="h-3.5 w-3.5" data-id="element-124" data-mp="22ajoa7m7bnt5" />
                      </span>
                      {f}
                    </li>)}
                </ul>
                <div className="mt-7 pt-2" data-id="element-125" data-mp="19mnrz40jnxww">
                  <Button as="a" href="#quote" variant="primary" className="w-full sm:w-auto" data-id="element-126" data-mp="19nfqamlj09qv">
                    Get Pricing
                    <ArrowRight className="h-4 w-4" data-id="element-127" data-mp="1eod7avusuxqs" />
                  </Button>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}